import React from 'react'

export const CloudIcon = (color = '#8797A1') => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_485_18917)">
        <path
          d="M16.1189 8.36634C15.5581 5.49134 13.0591 3.33301 10.0571 3.33301C7.67356 3.33301 5.60346 4.69967 4.57253 6.69967C2.09005 6.96634 0.160156 9.09134 0.160156 11.6663C0.160156 14.4247 2.37871 16.6663 5.10861 16.6663H15.8303C18.1065 16.6663 19.954 14.7997 19.954 12.4997C19.954 10.2997 18.2633 8.51634 16.1189 8.36634ZM11.7065 10.833V14.1663H8.40758V10.833H5.93335L10.0571 6.66634L14.1808 10.833H11.7065Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_485_18917">
          <rect
            width="19.7938"
            height="20"
            fill="white"
            transform="translate(0.160156)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
